import { render, staticRenderFns } from "./listClients.vue?vue&type=template&id=0bb78316&"
import script from "./listClients.vue?vue&type=script&lang=js&"
export * from "./listClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports